export const userLockConstants = {
    FETCH_REQUEST: 'USERLOCK_FETCH_REQUEST',
    FETCH_SUCCESS: 'USERLOCK_FETCH_SUCCESS',
    FETCH_FAILURE: 'USERLOCK_FETCH_FAILURE', 
};
